import { useNavigate } from "react-router-dom";
import Page from "../../finwell/pages/Page";
import CourseListLearnComp from "../../components/b2cComponents/CourseListLearnComp";
import {
  SessionKeys,
  clickStreamUser,
  getStepIndex,
} from "../../utils/AppUtils";
import { useEffect, useState } from "react";
import VideoListingContentComponent from "../../components/NewDesign/ListingContent/VideoListingContent/VideoListingContentComponent";
import CertificationListSection from "../../components/Certification/CertificationListSection";
import EventListSection from "../../components/NewDesign/Event/EventListSection";
import PartnerListSection from "../../components/NewDesign/Partner/PartnerListSection";
import CoachingListSection from "../../components/NewDesign/Coaching/CoachingListSection";
import RolePlayListingContent from "../../components/NewDesign/ListingContent/RolePlayListingContent/RolePlayListingContent";
import VideoListingSectionComponent from "../../components/NewDesign/ListingContent/VideoListingContent/VideoListingSectionComponent";
import _ from "lodash";
import RolePLaySectionOnly from "../RolePlay/RolePlaySectionOnly";
import { setJoyRideReq } from "../../redux/assignCourse/actions";
import { useDispatch, useSelector } from "react-redux";
import CourseListComboComp from "../../components/b2cComponents/CourseListComboComp";
import {
  getActiveHeader,
  getActiveHeaderClear,
  getNewContentCount,
} from "../../redux/home/actions";
import CoachingListSectionParent from "../../components/NewDesign/Coaching/CoachingListSectionParent";
import useLogin from "../../custom-hooks/useLogin";
import LPListLearnComp from "../../components/b2cComponents/LPListLearnComp";
import EventsCalendar from "../../components/Calendar/EventsCalendar";
import LearnMCSessionPage from "./EventPages/LearnMCSessionPage";
import { getDynamicText } from "../../redux/courses/actions";
import Coaching_Services_Section from "../../components/Coaching_Services/Coaching_Services_Section";
import { useTranslation } from "react-i18next";
import CoachingListing from "../../components/NewDesign/Halifax/Coaching/Listing/CoachingListing";
import { routeList } from "../../utils/routeList";
import ManageGroupWorkshop from "../../components/GroupWorkshop/ManageGroupWorkshop";
import MyBookingsComponent from "../../components/GroupWorkshop/MyBookingsComponent";
import AiCoaching from "../../components/NewDesign/Halifax/Coaching/Listing/AiCoaching";
import MsgModal from "../../components/modal/MsgModal";

const LearnParentPage = (props) => {
  const dispatch = useDispatch();
  const dynamicText = useSelector((state) => state.courses.dynamicTextRes);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const userRole = useSelector((state) => state.user.role);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const count_response = useSelector((state) => state.home.newContentCount);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [selectedSessionFromHome, setSelectedSessionFromHome] = useState({});
  const [selectedSessionPos, setSelectedSessionPos] = useState(0);
  const [confirmMsgModal, setConfirmMsgModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("This content is not available in your current subscription, please contact to Halifax Sales AI support team.");
  const toggleMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  };
  const closeMenu = () => {
    setIsOpenMenu(false);
  };
  useEffect(() => {
    if (localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
      getNewCount();
    }
  }, []);
  const { t } = useTranslation();

  useEffect(() => {
    // dispatch(
    //   getDynamicText({
    //     module: "get_Dynamic_Text",
    //     postData: {
    //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //     },
    //   })
    // );
  }, []);

  useEffect(() => {
    // if (dynamicText?.status === "success") {
    //   localStorage.setItem(
    //     SessionKeys.DYNAMIC_CONTENT,
    //     JSON.stringify(dynamicText?.payload[0])
    //   );
    // }
  }, [dynamicText]);

  const { isLoggedIn } = useLogin();

  const getNewCount = () => {
    dispatch(
      getNewContentCount({
        module: "newContentCount",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  };

  const [newContentCount, setNewContentCount] = useState({
    courses: 0,
    videos: 0,
  });

  useEffect(() => {
    if (!_.isEmpty(count_response)) {
      if (count_response?.status === "success") {
        console.log("count---", count_response);
        setNewContentCount({
          courses: count_response?.payload?.payload?.course_count,
          videos: count_response?.payload?.payload?.video_count,
        });
      }
    }
  }, [count_response]);

  const navigate = useNavigate();
  let routesVar = [
    { value: "courses", 
      label: "courses", 
      id: "idCoursesMenu",
      isLock: (_.isEmpty(authBroker) || (authBroker?.payload?.user?.access_type ===2 || authBroker?.payload?.user?.access_type ===1))?false:true
    },
    { value: "videos",
       label: "videos", 
       id: "idVideosMenu",
       isLock: (_.isEmpty(authBroker) || (authBroker?.payload?.user?.access_type ===2 || authBroker?.payload?.user?.access_type ===1))?false:true
       },
    {
      value: "learningpath",
      label: "learningPaths",
      id: "idLearningPathsMenu",
      isLock: (_.isEmpty(authBroker) || (authBroker?.payload?.user?.access_type ===2 || authBroker?.payload?.user?.access_type ===1))?false:true
    },
    // (localStorage.getItem(SessionKeys.API_TOKEN_BROKER) &&
    //   !authBroker.payload?.user.role.includes("customer") &&
    //   localStorage.getItem(SessionKeys.SHOW_ROLEPLAY) !== "false") || true &&
    false && {
      value: "coaching",
      label: "coaching",
      id: "idCoachingMenu",
    },
    false && {
      value: "certifications",
      label: "certifications",
      id: "idCertificationsMenu",
    },
    localStorage.getItem(SessionKeys.API_TOKEN_BROKER) &&
      !authBroker.payload?.user.role.includes("customer") &&
      localStorage.getItem(SessionKeys.SHOW_ROLEPLAY) !== "false" &&
      false && {
        value: "roleplay",
        label: "rolePlay",
        id: "idRolePlayMenu",
      },
    authBroker?.payload?.user?.ai_roleplay_token &&
      false && {
        value: "ai_roleplay",
        label: "AI Roleplay",
        id: "idAIRolePlayMenu",
      },
    false && { value: "events", label: "Events", id: "idEventsMenu" },
    //  { value: "manageworkshops", label:"Manage Workshops", id:"idManageWorkshops"},
    false && { value: "workshop", label: "groupWorkshop", id: "idEventsMenu" },
    {
      value: "coaching_services",
      label: "liveCoaching",
      id: "idCoachServices",
      isLock: (_.isEmpty(authBroker) || (authBroker?.payload?.user?.access_type ===2 || authBroker?.payload?.user?.access_type ===1))?false:true
    },
    localStorage.getItem(SessionKeys.NEW_AI_ROLEPLAY_TOKEN) && {
      value: "ai_coaching",
      label: "AI Coaching",
      id: "idAICoachingMenu",
      isLock:(_.isEmpty(authBroker) || (authBroker?.payload?.user?.access_type ===3 || authBroker?.payload?.user?.access_type ===1))?false:true
    },
    false && { value: "combo", label: "combo&Offers", id: "idComboMenu" },
    // {value: 'others', label: 'Others'},
  ];
  const [routes,setRoutes] = useState(routesVar);


  useEffect(() => {
    setRoutes(routesVar);
  }, [authBroker]);

  const routeTo = (type) => {
    switch (type) {
      case "courses":
        clickStreamUser("clicked", { route: "courses" });
        navigate("/learn/courses?tab=1");
        return;
      case "videos":
        clickStreamUser("clicked", { route: "videos" });
        navigate("/learn/videos");
        return;
      case "learningpath":
        clickStreamUser("clicked", { route: "videos" });
        navigate("/learn/learningpath?tab=3");
        return;
      // case "manageworkshops":
      //   clickStreamUser("clicked", { route: "manageworkshops" });
      //   navigate(routeList.MANAGE_WORKSHOP_LISTING);
      //   return;
      case "workshop":
        clickStreamUser("clicked", { route: "workshop" });
        navigate("/learn/group-workshops?tab=1");
        return;
      case "events":
        clickStreamUser("clicked", { route: "workshop" });
        navigate("/learn/events");
        return;
      case "certifications":
        clickStreamUser("clicked", { route: "certifications" });
        navigate("/learn/certifications");
        return;
      case "coaching":
        clickStreamUser("clicked", { route: "coaching" });
        navigate("/learn/coaching");
        return;
      case "roleplay":
        clickStreamUser("clicked", { route: "roleplay" });
        navigate("/learn/roleplay?tab=1");
        return;
      case "others":
        clickStreamUser("clicked", { route: "others" });
        navigate("/learn/others");
        return;
      case "combo":
        clickStreamUser("clicked", { route: "combo" });
        navigate("/learn/combo");
        return;
      case "ai_roleplay":
        clickStreamUser("clicked", { route: "ai_roleplay" });
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://demo.infiniit.ai/xsel/?token=${authBroker?.payload?.user?.ai_roleplay_token}` //https://demo.infiniit.ai/xsel-roleplay/?
            : `https://demo.infiniit.ai/xsel/?token=${authBroker?.payload?.user?.ai_roleplay_token}`,
          "_blank"
        );
        return;
      case "coaching_services":
        clickStreamUser("clicked", { route: "coaching" });
        navigate("/learn/coachingservices?tab=1");
        return;
      case "ai_coaching":
        clickStreamUser("clicked", { route: "ai_coaching" });
        navigate("/learn/ai-coaching");
        return;
      default:
        clickStreamUser("clicked", { route: "courses" });
        navigate("/learn/courses");
        return;
    }
  };

  const renderMainContent = () => {
    if (props.type) {
      switch (props.type) {
        case "courses":
          return <CourseListLearnComp />;
        case "videos":
          return <VideoListingSectionComponent />;
        case "learningpath":
          return <LPListLearnComp />;
        case "events":
          return <LearnMCSessionPage isEvents={true} />;
        case "workshop":
          return <LearnMCSessionPage isEvents={false} />; //<EventListSection />;
        case "certifications":
          return <CertificationListSection />;
        case "coaching":
          return <CoachingListSectionParent />;
        case "roleplay":
          return (
            <RolePlayListingContent />
            // <RolePLaySectionOnly />
          );
        // case 'others':
        //     return (
        //         <CourseListLearnComp />
        //     )
        case "partner":
          return <PartnerListSection />;
        case "combo":
          return <CourseListComboComp />;
        // case "manageworkshops":
        //     return <ManageGroupWorkshop />;
        case "coaching_services":
          return <Coaching_Services_Section />;
        // case "manage-workshop":
        //   return <ManageGroupWorkshop />;
        case "my-coaching-bookings":
          return <MyBookingsComponent />;
        case "ai_coaching":
          return <AiCoaching />;
        default:
          return;
      }
    } else {
      return <></>;
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {userRole === "provider" ? (
        ""
      ) : (
        <Page>
          <section className="bannersection">
            <div className="container mt-5">
              <div className="row justify-content-md-center">
                <div className="col-12 col-xl-2 col-lg-2 col-md-3 leftmenusec">
                  <div
                    className="d-xl-none btn-filter-mob"
                    onClick={toggleMenu}
                  >
                    Menu
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <path
                        d="M0 17.875C0 17.3164 0.429688 16.8438 1.03125 16.8438H3.56641C3.99609 15.4688 5.32812 14.4375 6.875 14.4375C8.37891 14.4375 9.71094 15.4688 10.1406 16.8438H20.9688C21.5273 16.8438 22 17.3164 22 17.875C22 18.4766 21.5273 18.9062 20.9688 18.9062H10.1406C9.71094 20.3242 8.37891 21.3125 6.875 21.3125C5.32812 21.3125 3.99609 20.3242 3.56641 18.9062H1.03125C0.429688 18.9062 0 18.4766 0 17.875ZM8.25 17.875C8.25 17.1445 7.60547 16.5 6.875 16.5C6.10156 16.5 5.5 17.1445 5.5 17.875C5.5 18.6484 6.10156 19.25 6.875 19.25C7.60547 19.25 8.25 18.6484 8.25 17.875ZM15.125 7.5625C16.6289 7.5625 17.9609 8.59375 18.3906 9.96875H20.9688C21.5273 9.96875 22 10.4414 22 11C22 11.6016 21.5273 12.0312 20.9688 12.0312H18.3906C17.9609 13.4492 16.6289 14.4375 15.125 14.4375C13.5781 14.4375 12.2461 13.4492 11.8164 12.0312H1.03125C0.429688 12.0312 0 11.6016 0 11C0 10.4414 0.429688 9.96875 1.03125 9.96875H11.8164C12.2461 8.59375 13.5781 7.5625 15.125 7.5625ZM16.5 11C16.5 10.2695 15.8555 9.625 15.125 9.625C14.3516 9.625 13.75 10.2695 13.75 11C13.75 11.7734 14.3516 12.375 15.125 12.375C15.8555 12.375 16.5 11.7734 16.5 11ZM20.9688 3.09375C21.5273 3.09375 22 3.56641 22 4.125C22 4.72656 21.5273 5.15625 20.9688 5.15625H11.5156C11.0859 6.57422 9.75391 7.5625 8.25 7.5625C6.70312 7.5625 5.37109 6.57422 4.94141 5.15625H1.03125C0.429688 5.15625 0 4.72656 0 4.125C0 3.56641 0.429688 3.09375 1.03125 3.09375H4.94141C5.37109 1.71875 6.70312 0.6875 8.25 0.6875C9.75391 0.6875 11.0859 1.71875 11.5156 3.09375H20.9688ZM6.875 4.125C6.875 4.89844 7.47656 5.5 8.25 5.5C8.98047 5.5 9.625 4.89844 9.625 4.125C9.625 3.39453 8.98047 2.75 8.25 2.75C7.47656 2.75 6.875 3.39453 6.875 4.125Z"
                        fill="#2D2D2D"
                      />
                    </svg>
                  </div>
                  <ul className={`sidebar ${isOpenMenu ? "openMenu" : ""}`}>
                    <span
                      className="close-menu d-xl-none cursor-pointer"
                      onClick={toggleMenu}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M15.1484 13.5781C15.5703 14.0469 15.5703 14.75 15.1484 15.1719C14.6796 15.6406 13.9765 15.6406 13.5546 15.1719L8.02344 9.59375L2.44532 15.1719C1.97656 15.6406 1.27344 15.6406 0.851559 15.1719C0.382814 14.75 0.382814 14.0469 0.851559 13.5781L6.42969 8L0.851559 2.42188C0.382814 1.95312 0.382814 1.25 0.851559 0.828125C1.27344 0.359375 1.97656 0.359375 2.39844 0.828125L8.02344 6.45312L13.6015 0.875C14.0234 0.40625 14.7265 0.40625 15.1484 0.875C15.6172 1.29688 15.6172 2 15.1484 2.46875L9.57034 8L15.1484 13.5781Z"
                          fill="#2D2D2D"
                        />
                      </svg>
                    </span>
                    {routes.map((r, i) => {
                      return !_.isEmpty(r) ? (
                        <li
                          id={r.id}
                          className={`${
                            props.type === r.value ? "activemenu" : ""
                          }`}
                          onClick={()=>{if(r.isLock){setConfirmMsgModal(true);} closeMenu()}}
                          key={i}
                        >
                          <button
                            className={r.isLock?"reset-btn disabled-div":"reset-btn cursor-pointer"}
                            onClick={() =>{if(r.isLock){setConfirmMsgModal(true); return;} routeTo(r.value)}}
                            
                            style={r.isLock ? { cursor: "not-allowed", opacity: 0.5 } : {}}
                          >
                            {t(`${r.label}`)}
                          </button>
                          {r.isLock ? <span class={"lock-bar lock-bar"}></span>
                          :isLoggedIn && r.label === "courses" ? (
                            newContentCount?.courses > 0 ? (
                              <span className="count">
                                {newContentCount?.courses}
                              </span>
                            ) : (
                              ""
                            )
                          ) : r.label === "videos" ? (
                            newContentCount.videos > 0 ? (
                              <span className="count">
                                {newContentCount?.videos}
                              </span>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </li>
                      ) : (
                        ""
                      );
                    })}
                  </ul>
                </div>
                <div className="col-12 col-xl-10 col-lg-10 col-md-9">
                  {renderMainContent()}
                </div>
              </div>
            </div>
          </section>
        </Page>
      )}
        <MsgModal
        confirmModal={confirmMsgModal}
        setConfirmModal={setConfirmMsgModal}
        showModalMsg={t(showModalMsg)}
        isConfirm={false}
        confirmId={""}
        confirmAction={function name(params) {}}
      />
    </>
  );
};
export default LearnParentPage;
